<div class="contract_wrap">
  <form [formGroup]="searchMaterialFormData">
    <div class="flex w-full flex-wrap gap-x-4 sm:flex-col">
      <div class="sm:w-full mx:w-[680px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <div class="flex">
              <div class="mx:w-[270px]">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                  <input (keydown.enter)="$event.preventDefault(); filterMarketingProcessMaterial()" nz-input type="text"
                    formControlName="activityRequestNo" [placeholder]="'活动申请编号'" />
                  <ng-template #suffixTemplateInfo>
                    <i class="search" (click)="filterMarketingProcessMaterial()"></i>
                  </ng-template>
                </nz-input-group>
              </div>
              <div class="mx:w-[270px]  ml-4">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                  <input (keydown.enter)="$event.preventDefault(); filterMarketingProcessMaterial()" nz-input type="text"
                    formControlName="verificationCode" [placeholder]="'核销编号'" />
                  <ng-template #suffixTemplateInfo>
                    <i class="search" (click)="filterMarketingProcessMaterial()"></i>
                  </ng-template>
                </nz-input-group>
              </div>
              <div class="mx:w-[270px] ml-4">
                <nz-select class="bosch-select" formControlName="productLine"
                  (ngModelChange)="filterMarketingProcessMaterial()" [nzSuffixIcon]="suffixSearch" nzPlaceHolder="产品线">
                  <nz-option *ngFor="let item of productLineList; let i = index" [nzValue]="item"
                    [nzLabel]="item"></nz-option>
                </nz-select>
                <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
              </div>
              <div class="mx:w-[270px] ml-4">
                <nz-select class="bosch-select" formControlName="approvalStatus"
                  (ngModelChange)="filterMarketingProcessMaterial()" [nzSuffixIcon]="suffixSearch" nzPlaceHolder="审批状态">
                  <nz-option *ngFor="let item of approvalStatusList; let i = index" [nzValue]="item"
                    [nzLabel]="item"></nz-option>
                </nz-select>
                <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[300px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-range-picker nzMode="year" class="w100 bosch-date-picker " formControlName="yearRange"
              (ngModelChange)="filterMarketingProcessMaterial()" [nzPlaceHolder]="['核销通过开始', '核销通过结束']"></nz-range-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full sm:mb-4 mx:w-[104px] flex">
        <button nz-button nzType="text" class="clear flex justify-center" (click)="clear()">
          <svg-icon [iconName]="'new/close-blue.svg'" [size]="20"></svg-icon> {{"CLEAR" | translate}}
        </button>
      </div>
    </div>
  </form>
  <nz-spin [nzSpinning]="loading" nzTip="加载中...">
    <div class="grid grid-cols-2 gap-6 p-4" style="background-color: #F4F6F8;" *ngIf="activityList.length>0">
      <div *ngFor="let data of activityList">
        <app-marketing-material-card [data]="data"></app-marketing-material-card>
      </div>
    </div>
  </nz-spin>
  <nz-pagination *ngIf="activityList.length>0" [nzPageIndex]="pageNum" [nzPageSize]="4" [nzTotal]="totalNum"
    style="text-align: right; margin-top: 10px;" (nzPageIndexChange)="onPageIndexChange($event)"></nz-pagination>
</div>